import Model from '@/models/Model'

export default class AccCostCenter extends Model {
    resource() {
        return 'acc_cost_center'
    }
}